import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { BankAccountKycDialogComponent } from '../bank-account-kyc-dialog/bank-account-kyc-dialog.component';
import { PrefillNoticeDialogComponent } from '../prefill-notice-dialog/prefill-notice-dialog.component';
import { FcAmbiguousAccountDialogComponent } from '../fc-ambiguous-account-dialog/fc-ambiguous-account-dialog.component';
import { BankAccountStripeOnboardingDialogComponent } from '../bank-account-stripe-onboarding-dialog/bank-account-stripe-onboarding-dialog.component';
import { BankAccountKycDialogStateService } from '../../../../services/stripe-treasury/bank-account-kyc-dialog-state.service';
import { PrefillNoticeDialogStateService } from '../../../../services/stripe-treasury/prefill-notice-dialog-state.service';
import { FcAmbiguousAccountDialogStateService } from '../../../../services/stripe-treasury/fc-ambiguous-account-dialog-state.service';
import { BankAccountStripeOnboardingDialogStateService } from '../../../../services/stripe-treasury/bank-account-stripe-onboarding-dialog-state.service';

/**
 * The dialogs the add-bank and link-balance journeys ask from inside `FinancialConnectionsService`,
 * mounted once at the app root. Those journeys start on about fifteen routes and outlive the click
 * that started them, so the dialogs cannot live in any one caller's template.
 *
 * Onboarding alone is created per opening (`*ngIf`): Stripe's iframe must be born after the dialog
 * lifts to the body-level layer, and a reopened live instance would move it.
 */
@Component({
    selector: 'app-bank-account-flow-dialogs-host',
    standalone: true,
    imports: [NgIf, BankAccountKycDialogComponent, PrefillNoticeDialogComponent, FcAmbiguousAccountDialogComponent, BankAccountStripeOnboardingDialogComponent],
    template: `
        <app-bank-account-kyc-dialog [open]="kyc.open()" (closed)="kyc.answer($event)"></app-bank-account-kyc-dialog>
        <app-prefill-notice-dialog [open]="prefillNotice.open()" [labels]="prefillNotice.data().labels" (closed)="prefillNotice.answer($event)"></app-prefill-notice-dialog>
        <app-fc-ambiguous-account-dialog [open]="ambiguousAccount.open()" [message]="ambiguousAccount.data().message" (closed)="ambiguousAccount.answer($event)"></app-fc-ambiguous-account-dialog>
        <app-bank-account-stripe-onboarding-dialog *ngIf="onboarding.open()" [open]="onboarding.open()" [organizationId]="onboarding.data().organizationId" (closed)="onboarding.answer($event)"></app-bank-account-stripe-onboarding-dialog>
    `,
})
export class BankAccountFlowDialogsHostComponent {
    constructor(
        readonly kyc: BankAccountKycDialogStateService,
        readonly prefillNotice: PrefillNoticeDialogStateService,
        readonly ambiguousAccount: FcAmbiguousAccountDialogStateService,
        readonly onboarding: BankAccountStripeOnboardingDialogStateService,
    ) {}
}
